import { Controller } from "@hotwired/stimulus";

// Powers the "reset to inherit" links on the widget variant form. Each overridable
// field is wrapped in a [data-field] element; clicking its reset link clears the
// field's input(s) so the blank value is submitted — the model's IntegrationOptions
// setter then drops the key and the field falls back to inheriting the shop value.
// Dispatching input/change keeps the colour swatch, dirty indicator, and live
// preview in sync, exactly as a manual edit would.
export default class extends Controller {
  reset(event) {
    event.preventDefault();
    const wrap = event.currentTarget.closest("[data-field]");
    if (!wrap) return;
    wrap.querySelectorAll("input, select, textarea").forEach((el) => {
      if (el.type === "color") return;
      if (el.type === "radio" || el.type === "checkbox") {
        el.checked = false;
      } else {
        el.value = "";
      }
      el.dispatchEvent(new Event("input", { bubbles: true }));
      el.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
}
